import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY;

function isConfiguredSupabase(url?: string, key?: string): boolean {
    if (!url || !key || key.length < 20 || /your-project|your-public/i.test(`${url} ${key}`)) return false;
    try {
        const parsed = new URL(url);
        return (parsed.protocol === 'https:' || parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1')
            && !parsed.username && !parsed.password;
    } catch {
        return false;
    }
}

export const supabase = supabaseUrl && supabaseAnonKey && isConfiguredSupabase(supabaseUrl, supabaseAnonKey)
    ? createClient(supabaseUrl, supabaseAnonKey, {
        auth: {
            autoRefreshToken: true,
            persistSession: true,
            detectSessionInUrl: true
        }
    })
    : null;

export const isBackendConfigured = Boolean(supabase);
